import React from "react";

const ContextMenu = ({ x, y, visible, onAction }) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: y,
        left: x,
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "5px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
      }}
    >
      <ul style={{ listStyleType: "none", margin: 0, padding: "10px" }}>
        <li
          onClick={() => onAction("add")}
          style={{ cursor: "pointer", padding: "5px 10px" }}
        >
          Add Category
        </li>
        <li
          onClick={() => onAction("edit")}
          style={{ cursor: "pointer", padding: "5px 10px" }}
        >
          Edit Category
        </li>
        <li
          onClick={() => onAction("delete")}
          style={{ cursor: "pointer", padding: "5px 10px", color: "red" }}
        >
          Delete Category
        </li>
      </ul>
    </div>
  );
};

export default ContextMenu;
